/*
  Уведомления должникам по выбранным в реестре счетам (20.10.2026).

  Одна дата на все уведомления - та, на которую считаются долг и пени, как
  «Дата пакета» в карточке счёта. Отказы приходят по счёту (нет долга, не указан
  вид собственности) и не отменяют уведомления по остальным; что не собралось и
  почему, страница показывает после закрытия окна. Собранные уведомления лежат в
  карточке каждого счёта, в списке документов.
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { accounts } from '../api/format.js'
import { Field, Notice } from './Common.jsx'
import Modal from './Modal.jsx'

/* Местная дата, а не UTC: после трёх ночи по Москве `toISOString()` даёт вчера. */
function today() {
  const now = new Date()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  return `${now.getFullYear()}-${month}-${day}`
}

export default function NoticeBulkDialog({ chosen, onClose, onBuilt }) {
  const [asOf, setAsOf] = useState(today())
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  async function submit(event) {
    event.preventDefault()
    setBusy(true)
    setError(null)
    try {
      onBuilt(
        await api.buildNotices(
          chosen.map((row) => row.account_id),
          asOf,
        ),
      )
    } catch (failure) {
      setError(failure)
      setBusy(false)
    }
  }

  return (
    // Пока идёт сборка, окно не закрывается ни Escape, ни щелчком мимо (21.10.2026,
    // ревью): закрытое посреди сборки окно открывали снова, и второй запрос
    // собирал дубли - второе уведомление тому же должнику со второй живой ссылкой
    // (с 21.10.2026 повторная сборка прежнюю ссылку не гасит, строка 261 реестра).
    <Modal title={`Уведомления: ${accounts(chosen.length)}`} onClose={onClose} busy={busy}>
      <form onSubmit={submit}>
        {/* Абзац и поле - двумя блоками окна: в одном подпись поля прилипала к
            абзацу (осмотр 20.10.2026), а у блока окна свой отступ снизу. */}
        <div className="modal__text">
          По каждому счёту - уведомление на каждого должника, со своей ссылкой на оплату на 45
          дней. Уведомления появятся в карточках счетов, в списке документов.
        </div>
        <div className="modal__text">
          <div className="row">
            <Field
              label="Дата расчёта"
              width="s"
              hint="На эту дату считаются долг и пени в уведомлениях. Поставьте ту же, что в пакете для суда: уведомление прикладывается к заявлению, и суммы должны совпасть."
            >
              <input
                className="field__input"
                type="date"
                value={asOf}
                onChange={(event) => setAsOf(event.target.value)}
                required
              />
            </Field>
          </div>
        </div>
        <Notice error={error} />
        {busy ? <div className="muted">Собираю уведомления - это может занять до минуты.</div> : null}
        <div className="row row--tight">
          <button type="submit" className="button" disabled={busy || !asOf}>
            Сформировать уведомления
          </button>
          <button type="button" className="button button--quiet" onClick={onClose} disabled={busy}>
            Отмена
          </button>
        </div>
      </form>
    </Modal>
  )
}
